document.addEventListener("DOMContentLoaded", function () {
  rollerInit();
  setupObservers();
});

function numberRoller(slno) {
  var el = document.querySelector(".roller-title-number-" + slno);
  if (!el) return;

  var min = parseInt(el.getAttribute("data-min"), 10) || 0;
  var max = parseInt(el.getAttribute("data-max"), 10) || 100;
  var delay = parseInt(el.getAttribute("data-delay"), 10) || 1;
  var increment = parseInt(el.getAttribute("data-increment"), 10) || 1;
  var timeout = (1000 * delay) / (max - min);

  numberRoll(el, min, max, increment, timeout);
}

function numberRoll(el, current, max, increment, timeout) {
  if (current <= max) {
    el.textContent = current;
    setTimeout(function () {
      numberRoll(el, current + increment, max, increment, timeout);
    }, timeout);
  } else {
    el.textContent = max;
  }
}

function rollerInit() {
  var els = document.querySelectorAll(".numscroller");
  for (var i = 0; i < els.length; i++) {
    var el = els[i];
    var id = i + 1;
    el.setAttribute("data-slno", id);
    el.className += " roller-title-number-" + id;
  }
}

function setupObservers() {
  var observer = new IntersectionObserver(function (entries, obs) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting) {
        var el = entry.target;
        if (el.className.indexOf("isShown") === -1) {
          el.className += " isShown";
          numberRoller(el.getAttribute("data-slno"));
          obs.unobserve(el);
        }
      }
    }
  }, {
    threshold: 0.2
  });

  var elements = document.querySelectorAll(".numscroller");
  for (var j = 0; j < elements.length; j++) {
    observer.observe(elements[j]);
  }
}
